import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'

import Home from '../components/home/Home'
import SuperMidWet from '../components/supermidpassdown/SuperMidWet'
import SuperMidDry from '../components/supermidpassdown/SuperMidDry'
import SuperEndWet from '../components/superendpassdown/SuperEndWet'
import SuperEndDry from '../components/superendpassdown/SuperEndDry'
import Vr from '../components/vrpassdown/Vr'

import Nav from '../components/shared/Nav'
import NotFound from '../components/shared/NotFound'
import Loading from '../components/shared/Loading'

import PrivateRoute from './PrivateRoute'
import { useLoading } from '../contexts/LoadingContext'

const AppRouter = () => {
  const { loading } = useLoading()
  return (
    <>
      <Toaster
        toastOptions={{
          position: 'bottom-center',
          duration: 5000,
          style: {
            zIndex: 120000,
          },
        }}
      />
      {loading && <Loading />}
      <BrowserRouter>
        <Nav />
        <Routes>
          <Route path='/' element={<Home />} exact />

          <Route
            path='/supermidwet'
            element={
              <PrivateRoute>
                <SuperMidWet />
              </PrivateRoute>
            }
            exact
          />
          <Route
            path='/supermidwet/:id'
            element={
              <PrivateRoute>
                <SuperMidWet />
              </PrivateRoute>
            }
            exact
          />
          <Route
            path='/supermiddry'
            element={
              <PrivateRoute>
                <SuperMidDry />
              </PrivateRoute>
            }
            exact
          />
          <Route
            path='/supermiddry/:id'
            element={
              <PrivateRoute>
                <SuperMidDry />
              </PrivateRoute>
            }
            exact
          />
          <Route
            path='/superendwet'
            element={
              <PrivateRoute>
                <SuperEndWet />
              </PrivateRoute>
            }
            exact
          />
          <Route
            path='/superendwet/:id'
            element={
              <PrivateRoute>
                <SuperEndWet />
              </PrivateRoute>
            }
            exact
          />
          <Route
            path='/superenddry'
            element={
              <PrivateRoute>
                <SuperEndDry />
              </PrivateRoute>
            }
            exact
          />
          <Route
            path='/superenddry/:id'
            element={
              <PrivateRoute>
                <SuperEndDry />
              </PrivateRoute>
            }
            exact
          />
          <Route
            path='/vr'
            element={
              <PrivateRoute>
                <Vr />
              </PrivateRoute>
            }
            exact
          />
          <Route
            path='/vr/:id'
            element={
              <PrivateRoute>
                <Vr />
              </PrivateRoute>
            }
            exact
          />

          <Route path='*' element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default AppRouter
